import { cookieConsentManager } from './CookieConsentManager'

export function writeGaEvent(vm, eventCategory, eventAction, eventLabel, eventValue) {
  // Check cookie consent for analytics first
  if (!cookieConsentManager.hasConsent('analytics')) {
    console.warn(`[Analytics Blocked] ${eventCategory || 'GA Event'} - Analytics cookies are not consented to.`)
    return
  }

  console.info('GA Event disabled.')
}
